import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import LandingPage from '@/pages/LandingPage';
import Dashboard from '@/pages/Dashboard';
import Training from '@/pages/Training';
import Integration from '@/pages/Integration';
import UserGuide from '@/pages/UserGuide';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  // Dev bypass for testing - check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const devMode = urlParams.get('dev') === 'true';

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  }

  return (isAuthenticated || devMode) ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/training"
            element={
              <PrivateRoute>
                <Training />
              </PrivateRoute>
            }
          />
          <Route
            path="/integration"
            element={
              <PrivateRoute>
                <Integration />
              </PrivateRoute>
            }
          />
          <Route
            path="/guide"
            element={
              <PrivateRoute>
                <UserGuide />
              </PrivateRoute>
            }
          />
        </Routes>
      </Layout>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRoutes />
      </div>
    </AuthProvider>
  );
}

export default App;
